var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"htmlpage"}},[_c('iframe',{attrs:{"height":"100%","width":"100%","srcdoc":_vm.srcdoc}})])}
var staticRenderFns = []

export { render, staticRenderFns }